import { Component } from '@angular/core';
import { Router, ChildActivationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { RoutingStateService } from 'src/services/RoutingState.service';
import { Observable } from 'rxjs/internal/Observable';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { Subscription } from 'rxjs';
import { RolePrivilegeManagerService } from 'src/services/service/role-privilege-manager.service';
// import { fromEvent } from 'rxjs/internal/observable/fromEvent';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'CAC Data-Entry Application';
  currentRole: any;

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];

  connectionStatusMessage: string;
  connectionStatus: string;
  dis: boolean;

  constructor(public router: Router, private titleService: Title, public routingState: RoutingStateService,public role: RolePrivilegeManagerService) {

    this.router.events
        .pipe(filter(event => event instanceof ChildActivationEnd))
        .subscribe(event => {
            let snapshot = (event as ChildActivationEnd).snapshot;
            while (snapshot.firstChild !== null) {
                snapshot = snapshot.firstChild;
            }
            let data = this.sanitizeData(snapshot.data, snapshot.params);
            this.titleService.setTitle(data.title || this.title);
        });
    this.routingState.loadRouting();
    this.currentRole = JSON.parse(sessionStorage.getItem('PortalUserRole'));
  }

  ngOnInit(): void {}


  ngOnDestroy(): void {
    /**
    * Unsubscribe all subscriptions to avoid memory leak
    */
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onActivate(event: any) {
    window.scroll(0, 0);
  }

  sanitizeData(data:any, params:any){
    for(const[field, value] of Object.entries(params)){
      let reg = ":"+field;
      let valueData = <string>value;
      valueData = valueData.replace("-", " ").toUpperCase();

      if (data.title && data.title.indexOf(reg) > -1){
        data.title = data.title.replace(reg, valueData);
      }

      if (data.breadcrumbs){
        for(let i=0; i < data.breadcrumbs.length; i++){
          if (data.breadcrumbs[i].text && data.breadcrumbs[i].text.indexOf(reg) > -1){
            data.breadcrumbs[i].text = data.breadcrumbs[i].text.replace(reg, valueData);
          }
          if (data.breadcrumbs[i].link && data.breadcrumbs[i].link.indexOf(reg) > -1){
            data.breadcrumbs[i].link = data.breadcrumbs[i].link.replace(reg, valueData);
          }
        }
      }
    }
    return data;
  }




}
